import { ECathegory, EHelpType, THelp } from "../types"
import { GAMES, gameType, getPointsText } from "../utils"
import { Modal } from "./Modal"

type ConfirmHelpModalProps = {
    open: boolean
    handleClose: any
    help: THelp
    approve: any,
    cathegory: ECathegory | undefined
}

export const ConfirmHelpModal = ({ open, handleClose, help, approve, cathegory }: ConfirmHelpModalProps) => {



    function getHelpConfitmText(help: THelp) {
        switch (help.type) {
            case EHelpType.NORMAL:
                return `Za použití této nápovědy je penalizace: ${getPointsText(help.points, cathegory, help.type)}!`        
            case EHelpType.INSTRUCTIONS:
                {
                    switch (gameType()) {
                        case GAMES.SIFT:
                            return `Za použití této nápovědy je penalizace: ${getPointsText(help.points, cathegory, help.type)}!`  
                        case GAMES.ZKRATKA:
                            return `Za vyluštění šifry s touto nápovědou dostanete vždy o 8 bodů méně, bez ohledu na to, jestli jste brali klasické nápovědy.` 
                        case GAMES.HIDDEN:
                            return ""
                    }
                }
            case EHelpType.ABSOLUTE:
                {
                    switch (gameType()) {
                        case GAMES.SIFT:
                            switch (cathegory) {
                                case ECathegory.Z:
                                    return `Za použití této nápovědy je penalizace: ${getPointsText(help.points, cathegory, help.type)}!`
                                case ECathegory.P:
                                    return `Při použití této nápovědy se vám šifra nebude počítat jako vyřešená, ale budete moci pokračovat dále ve hře.`
                            }
                            return''
                        case GAMES.ZKRATKA:
                            return `Za šifru nezískáte žádné body!`
                        case GAMES.HIDDEN:
                            return ""
                    }
                }
            case EHelpType.MINI:
                return `Za použití této nápovědy je penalizace: ${getPointsText(help.points, cathegory, help.type)}!`
            default: return ""
        }
    }

    return (
        <Modal headline='Potvrdit' open={open} handleClose={handleClose }>
            <div>
                {getHelpConfitmText(help)}
                <div className='modal__buttons'>
                    <button className='button' onClick={approve}> Vzít nápovědu</button>
                </div>
            </div>
        </Modal>
    )
}